module.exports = __webpack_public_path__ + "assets/img/modal-avatar-98955aa5.png";